import { affiliateLinkClicksRef } from "@/fireinit.js";
import axios from "axios";
import Vue from "vue";

export default {
  loadAll: async ({ commit, rootState }) => {
    const response = await axios.get(
      `${rootState.axios.API}affiliateLinkClick/all`,
      {
        headers: {
          Authorization: `Bearer ${rootState.user.data.auth._lat}`,
        },
      }
    );
    let affiliateLinkClicksList = [];
    response.data.forEach((affiliateClick) => {
      affiliateLinkClicksList.push({
        ...affiliateClick,
      });
    });
    commit("setAffiliateLinkClicksList", affiliateLinkClicksList);
  },
  delete: async ({ commit }, affiliateLinkClickId) => {
    return affiliateLinkClicksRef.doc(affiliateLinkClickId).delete();
  },
  save: async ({ commit, rootState }, affiliateClick) => {
    await axios.post(
      `${rootState.axios.API}affiliateLinkClick/create`,
      affiliateClick
    );
  },
};
